// import external dependencies
// import 'jquery'; // Enable only if required, already loaded in my uplers theme

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import gsap from 'gsap';
import CustomEase from 'gsap/CustomEase';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);

CustomEase.create('easeInCirc', '0.55, 0, 1, 0.45');
CustomEase.create('easeOutCirc', '0, 0.55, 0.45, 1');
CustomEase.create("easeInOutCirc", "0.85, 0, 0.15, 1");

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common
});

// Load Events
jQuery(function() {
  routes.loadEvents()
});



// WEBPACK FOOTER //
// ./scripts/main.js